// Replace YOUR_CLOUD_NAME with your Cloudinary cloud name (found in your Cloudinary dashboard)
const CLOUD = 'du1qbzxhv';

const BASE = `https://res.cloudinary.com/${CLOUD}/image/upload/f_auto,q_auto`;

export const cloudImg = (filename) => `${BASE}/${filename}`;
